import { WatermarkImage } from "../../../util";
import "./index.css";

function Watermark() {
  return (
    <div className="Watermark resultpage">
      <img alt="" src={WatermarkImage} />
    </div>
  );
}

export default Watermark;
